import { Container, useTheme, useMediaQuery } from "@mui/material"
import { Box } from "@mui/system"
import Page from "src/components/Page"
import useLocales from "src/hooks/useLocales"
import { HEADER, NAVBAR } from "src/config";
import useCollapseDrawer from "src/hooks/useCollapseDrawer";
import { env } from "src/config/env";

export const ProviderKnowledgeBase = () => {
    const { translate } = useLocales()

    const { isCollapse } = useCollapseDrawer();
    const theme = useTheme();
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));

    const frameSource = env.links.providerNotionPage

    
    const collapseOffsetWidth = isLargeScreen 
        ? (isCollapse ? NAVBAR.MAIN_COLLAPSE_WIDTH : NAVBAR.MAIN_WIDTH)
        : 0

    const collapseOffsetHeight = isLargeScreen? 0: HEADER.MOBILE_HEIGHT

    if (!frameSource) {
        return (
            <Page title={translate('pages.providerKnowledgeBase.title')}>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    Notion page is not configured.
                </Box>
            </Page>
        )
    }
    return (
        <Page title={translate('pages.providerKnowledgeBase.title')}>
            <Box
                sx={{
                    position: 'fixed',
                    bottom: 0,
                    width: `calc(100% - ${collapseOffsetWidth}px)`,
                    height: `calc(100vh - ${collapseOffsetHeight}px)`,
                    zIndex: isLargeScreen?1300:1,
                }}
            >
                <iframe
                    src={frameSource}
                    style={{
                        width: '100%',
                        height: '100%',
                        border: 'none'
                    }}
                    title="Knowledge Base"
                />

            </Box>
            
        </Page>
    )
}
